import { createAction, props } from '@ngrx/store';
import { JobTypeServiceCreateResponseJson } from '@vmspdb/definitions';

export const deleteJobType = createAction(
  '[JobType/API] Delete JobType',
  props<{ item: JobTypeServiceCreateResponseJson }>(),
);
